(function () {
  const STORAGE_PREFIX = 'pcd:collection-load-more:';
  const RESTORE_INTENT_KEY = 'pcd:collection-load-more:restore-intent';
  const STATE_TTL = 30 * 60 * 1000;

  function getStateKey() {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.hash = '';
    return `${STORAGE_PREFIX}${url.pathname}?${url.searchParams.toString()}`;
  }

  function getGrid() {
    return document.querySelector('#ProductGridContainer #product-grid');
  }

  function getControls() {
    return document.querySelector('#ProductGridContainer [data-pcd-load-more]');
  }

  function getSectionId() {
    const grid = getGrid();
    return grid ? grid.dataset.id : null;
  }

  function updateAnimationOrder(items, startIndex) {
    items.forEach((item, index) => {
      if (item.classList.contains('scroll-trigger')) {
        item.classList.add('scroll-trigger--cancel');
      }

      item.style.setProperty('--animation-order', startIndex + index + 1);
    });
  }

  function saveState() {
    const grid = getGrid();
    const controls = getControls();

    if (!grid || !controls) return;

    const state = {
      savedAt: Date.now(),
      gridHtml: grid.innerHTML,
      controlsHtml: controls.innerHTML,
      scrollY: window.scrollY,
    };

    try {
      sessionStorage.setItem(getStateKey(), JSON.stringify(state));
    } catch (error) {
      // Storage can fail in private browsing. The list still works without restore.
    }
  }

  function restoreState() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('page')) return;

    const key = getStateKey();
    if (sessionStorage.getItem(RESTORE_INTENT_KEY) !== key) return;

    const grid = getGrid();
    const controls = getControls();
    const rawState = sessionStorage.getItem(key);

    if (!grid || !controls || !rawState) return;

    try {
      const state = JSON.parse(rawState);
      if (!state.savedAt || Date.now() - state.savedAt > STATE_TTL) {
        sessionStorage.removeItem(key);
        sessionStorage.removeItem(RESTORE_INTENT_KEY);
        return;
      }

      grid.innerHTML = state.gridHtml;
      controls.innerHTML = state.controlsHtml;

      window.requestAnimationFrame(() => {
        window.scrollTo(0, state.scrollY || 0);
      });
    } catch (error) {
      sessionStorage.removeItem(key);
      sessionStorage.removeItem(RESTORE_INTENT_KEY);
    }
  }

  function setButtonLoading(button, isLoading) {
    const label = button.querySelector('[data-pcd-load-more-label]');
    const loadingText = button.dataset.loadingText || '読み込み中...';

    if (isLoading) {
      button.dataset.originalLabel = label ? label.textContent : button.textContent;
      if (label) label.textContent = loadingText;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      return;
    }

    if (label && button.dataset.originalLabel) {
      label.textContent = button.dataset.originalLabel;
    }
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
  }

  function buildSectionUrl(url, sectionId) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set('section_id', sectionId);
    return nextUrl;
  }

  async function loadMore(button) {
    const grid = getGrid();
    const controls = getControls();
    const sectionId = getSectionId();

    if (!grid || !controls || !sectionId || button.classList.contains('is-loading')) return;

    setButtonLoading(button, true);

    try {
      const response = await fetch(buildSectionUrl(button.href, sectionId).toString(), {
        credentials: 'same-origin',
      });

      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextItems = Array.from(parsed.querySelectorAll('#product-grid .grid__item'));
      const nextControls = parsed.querySelector('[data-pcd-load-more]');

      if (!nextItems.length || !nextControls) throw new Error('Could not find next products.');

      const startIndex = grid.children.length;
      updateAnimationOrder(nextItems, startIndex);
      nextItems.forEach((item) => grid.appendChild(item));
      controls.innerHTML = nextControls.innerHTML;

      saveState();
    } catch (error) {
      window.location.href = button.href;
    } finally {
      setButtonLoading(button, false);
    }
  }

  document.addEventListener('click', (event) => {
    const loadMoreButton = event.target.closest('[data-pcd-load-more-button]');
    if (loadMoreButton) {
      event.preventDefault();
      loadMore(loadMoreButton);
      return;
    }

    const productLink = event.target.closest('#ProductGridContainer #product-grid a[href*="/products/"]');
    if (productLink) {
      saveState();
      try {
        sessionStorage.setItem(RESTORE_INTENT_KEY, getStateKey());
      } catch (error) {
        // Ignore storage failures; normal browser history still works.
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreState);
  } else {
    restoreState();
  }

  document.addEventListener('shopify:section:load', restoreState);
})();
